export default __webpack_public_path__ + "static/media/payment_failed_illustration.f3dc8b5b.svg";